import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [busy, setBusy] = useState(false);
  const forced = user?.must_change_password;
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.again) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      if (data.token) localStorage.setItem("hs_token", data.token);
      setUser(data.user);
      toast.success("Password aggiornata");
      nav(data.user.cassa_client_id ? "/account/negozio" : "/account", { replace: true });
    } catch (x) { toast.error(errMsg(x)); }
    setBusy(false);
  };
  const inp = "w-full h-12 px-3 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-brand-yellow";
  return (
    <div className="max-w-md mx-auto px-4 py-14" data-testid="change-password-page">
      <form onSubmit={submit} className="rounded-2xl border bg-white p-7 space-y-4 shadow-sm">
        <KeyRound className="w-8 h-8 text-brand-navy" />
        <h1 className="text-3xl font-extrabold uppercase text-brand-navy">{forced ? "Scegli la tua password" : "Cambia password"}</h1>
        {forced && <p className="text-sm text-slate-600">Hai effettuato l'accesso con la password temporanea ricevuta via email. Sceglierne una nuova per continuare.</p>}
        <input data-testid="chpwd-current" type="password" required placeholder={forced ? "Password temporanea" : "Password attuale"} className={inp} value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} />
        <input data-testid="chpwd-new" type="password" required minLength={8} placeholder="Nuova password (min. 8 caratteri)" className={inp} value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} />
        <input data-testid="chpwd-again" type="password" required minLength={8} placeholder="Ripeti la nuova password" className={inp} value={f.again} onChange={(e) => setF({ ...f, again: e.target.value })} />
        <button data-testid="chpwd-submit" disabled={busy} className="press w-full h-12 rounded-md bg-brand-navy text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Salva password</button>
      </form>
    </div>
  );
}
